<div class="main-container">

  <div class="page-header">
    <div class="title">
      <span class="title-text">Manage Roles</span>
      <p class="small-title">Roles and the views/permissions each role grants.</p>
    </div>
    <div class="header-actions">
      <button type="button" class="ac-primary-btn" [disabled]="isLoading" (click)="addRole()">Add Role</button>
    </div>
  </div>

  <div class="table-container ac-table-region" role="region" aria-label="Roles" tabindex="0">
    <table class="table ac-responsive-table">
      <thead class="table-head">
        <tr>
          <th scope="col">Name</th>
          <th scope="col">Key</th>
          <th scope="col">Priority</th>
          <th scope="col">Applicable for</th>
          <th scope="col">Scope</th>
          <th scope="col">Grants all</th>
          <th scope="col">Status</th>
          <th scope="col">Actions</th>
        </tr>
      </thead>
      <tbody class="table-body">
        @for(role of roles; track role.roleId){
        <tr>
          <td data-label="Name">{{ role.roleName }}</td>
          <td data-label="Key">{{ role.roleKey }}</td>
          <td data-label="Priority">{{ role.rolePriority }}</td>
          <td data-label="Applicable for">{{ role.applicableFor }}</td>
          <td data-label="Scope">{{ role.scope }}</td>
          <td data-label="Grants all">{{ role.grantsAllAccess ? 'Yes' : 'No' }}</td>
          <td data-label="Status">{{ role.status === 1 ? 'Active' : 'Inactive' }}</td>
          <td class="ac-actions-column actions-cell" data-label="Actions">
            <button type="button" class="ac-secondary-small-btn" (click)="editRole(role)">Edit</button>
            <button type="button" class="ac-secondary-small-btn" (click)="manageViews(role)">Views</button>
          </td>
        </tr>
        }
        @if(!isLoading && roles.length === 0){
        <tr>
          <td colspan="8" class="empty-row">No roles found.</td>
        </tr>
        }
      </tbody>
    </table>
  </div>

</div>

<app-loader [isLoading]="isLoading"></app-loader>
